import { useState } from "react";
import { useNavigate } from "react-router-dom";
import globalHome2 from "../Assets/gia2.jpeg";

function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      const res = await fetch(
        "https://backend-global-1vq9.onrender.com/api/auth/forgot-password",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      setMessage("Password reset link sent to your email");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#FFFFFF",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(180deg, #E6F7FD, #FFFFFF)",
          padding: "80px 20px 40px",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            color: "#010101",
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "12px",
          }}
        >
          Forgot Password
        </h1>
        <p
          style={{
            color: "#6C6C6C",
            fontSize: "1rem",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          Enter your email and we’ll send you a link to reset your password.
        </p>
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "40px",
          padding: "20px",
          flex: 1,
        }}
      >
        <img
          src={globalHome2}
          alt="illustration"
          style={{
            width: "450px",
            maxWidth: "100%",
            height: "30%",
            borderRadius: "0.5rem",
          }}
        />

        <div
          style={{
            flex: "1 1 350px",
            maxWidth: "400px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
            required
          />

          {error && (
            <div style={{ color: "red", fontSize: "14px", textAlign: "center" }}>
              {error}
            </div>
          )}

          {message && (
            <div
              style={{
                color: "#00AEEF",
                fontSize: "14px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {message}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
              border: "none",
              borderRadius: 8,
              padding: "14px",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "16px",
              cursor: "pointer",
              width: "100%",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          <p
            style={{
              textAlign: "center",
              fontSize: "14px",
              color: "#6C6C6C",
            }}
          >
            Remembered your password?{" "}
            <span
              style={{
                color: "#00AEEF",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => navigate("/login")}
            >
              Sign In
            </span>
          </p>
        </div>
      </form>
    </div>
  );
}

const inputStyle = {
  border: "1px solid #E6E6E6",
  borderRadius: 8,
  padding: "12px 16px",
  background: "#fff",
  fontSize: "14px",
  color: "#6C6C6C",
  outline: "none",
  width: "100%",
};

export default ForgotPassword;
